/** @jsx isolateComponent */
import { useState } from 'react';

import { isolateComponent } from '@zapier/style-encapsulation';
import { Button, Text } from '@zapier/design-system';

import PositiveFeedback from '../PositiveFeedback';
import { SizeType } from '../../../../types';

type FeedbackProps = {
  /** Called when you click 'No, what’s next?' or 'Yes, thank you' and then 'see more solutions'. */
  onGoToNextStep: () => void;
  /** Size to display. */
  size: SizeType;
};

const Styles = {
  inner: {
    alignItems: 'center',
    display: 'grid',
    gridGap: 20,
    gridTemplateColumns: '1fr min-content min-content',
    justifyItems: 'end',
  },
  innerSmall: {
    gridTemplateColumns: '1fr',
    justifyItems: 'start',
  },
  root: {
    display: 'grid',
    gridGap: 60,
  },
};

/**
 * Displayed on all but the last stage of the `<HelpBlock>` component.
 */
const Feedback = ({ onGoToNextStep, size }: FeedbackProps) => {
  const [didSolve, setDidSolve] = useState<boolean>();

  const didProvideFeedback = typeof didSolve === 'boolean';
  const yesColor = didProvideFeedback ? 'tertiary' : 'secondary';
  const onClickYes = () => setDidSolve(true);
  const onClickNo = () => {
    setDidSolve(false);
    onGoToNextStep();
  };

  return (
    <div css={Styles.root}>
      <div css={[Styles.inner, size === 'small' && Styles.innerSmall]}>
        <Text type="Body3">Did this solve your issue?</Text>
        <Button variant={yesColor} onPress={onClickYes}>
          Yes, thank you
        </Button>
        <Button
          variant="primary"
          isDisabled={didProvideFeedback}
          onPress={onClickNo}
        >
          No, what’s next?
        </Button>
      </div>
      {didSolve && <PositiveFeedback />}
    </div>
  );
};

export default Feedback;
